// Translations
import form from '../sections/form/translations/ru'

// Translation: Password change > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
